import styles from '@/styles/Loading.module.scss'
import React from 'react'

export const Loading = () => {
  return (
    <div className={styles.p_loading}>
      <div className={styles.p_loading_wrap}>
        <div className={styles.loading} />
      </div>
    </div>
  )
}
